export default __webpack_public_path__ + "img/daXFdqiP.6a3e8366.svg";